import script from "./KiwishMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./KiwishMenu.vue?vue&type=script&setup=true&lang=js"

import "./KiwishMenu.vue?vue&type=style&index=0&id=77c29db7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c29db7"]])

export default __exports__